import type { App } from 'vue'
import store from '@/store'

// Allow manual override for future migrations, but default to store
let manualUserGroups: string[] | null = null

const setUserGroups = (groups: string[]) => {
  manualUserGroups = groups
}

const getUserGroups = (): string[] => {
  // Prioritize manual groups if set, otherwise read from store
  return manualUserGroups ?? store.getters['user/getUserGroups']
}

const checkGroup = ({ groups, negate = false }: { groups: string | string[]; negate?: boolean; }): boolean => {
  const userGroups = getUserGroups()
  const normalizedGroups = Array.isArray(groups) ? groups : [groups]
  const match = normalizedGroups.some((g) => userGroups.includes(g))

  return negate ? !match : match
}

const $userInGroup = (groups: string | string[]) => checkGroup({ groups })

const $userNotInGroup = (groups: string | string[]) => checkGroup({ groups, negate: true })

export {
  checkGroup,
  $userInGroup,
  $userNotInGroup,
  setUserGroups,
  getUserGroups,
}

export default {
  install(app: App) {
    app.config.globalProperties.$userInGroup = $userInGroup
    app.config.globalProperties.$userNotInGroup = $userNotInGroup
  },
}
